export const saveDialog = {
  title: "Leave without saving?",
  text: "You have made changes. Are you sure you want to leave the page without saving?",
  close: "Leave without saving",
  save: "Save and go back"
};
